export default "/static/dashboard/build/app/img/v2/12fb12aba741a92daed62c8d3af1198d.png";